import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ChatBotPage from '../../pages/chatbot/chatbot';
import { KNOWN_ROUTES } from '../../routesConfig';
import './FloatingChatBot.css';


function FloatingChatBot() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Alterna la visibilidad del chatbot
  const toggleChatBot = () => {
    setIsOpen(!isOpen);
  };

  if (
    location.pathname.startsWith('/panel-admin')
    || location.pathname === '/confirmar-correo'
    || !KNOWN_ROUTES.includes(location.pathname)
  ) return null;

  return (
    <>
      {/* Botón flotante que abre/cierra el chatbot */}
      <div className="floating-chatbot" onClick={toggleChatBot}>
        <div className="sphere"></div>
      </div>

      {/* Ventana del chatbot */}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <img src="/img/logo sin fondo.png" alt="Kredilibranza" className="chatbot-header-logo" />
            <span className="chatbot-header-title">Kredilibranza</span>
            <button className="close-button" onClick={toggleChatBot} aria-label="Cerrar chat">×</button>
          </div>
          <ChatBotPage />
        </div>
      )}
    </>
  );
}

export default FloatingChatBot;
